<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="应用类型：">
            <el-select style="width: 150px;" v-model="formInline.appType" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                    v-for="item in appTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="应用名称：">
            <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="success" @click="showAdd()">新建</el-button>
        </el-form-item>
    </el-form>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="ID" width="80">
            <template #default="scope">
                <div>
                    <span>{{ scope.row.id }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="应用名称" width="200" show-overflow-tooltip>
            <template #default="scope">
                <div>
                    <span>{{ scope.row.appName || '--' }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="应用类型" width="120">
            <template #default="scope">
                <div>
                    <span>{{ appTypeFilter(scope.row.appType) }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="应用第三方ID" min-width="200" show-overflow-tooltip>
            <template #default="scope">
                <div>
                    <span>{{ scope.row.appThirdId || '--' }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="应用密钥" min-width="300" show-overflow-tooltip>
            <template #default="scope">
                <div>
                    <span>{{ scope.row.appSecret || '--' }}</span>
                </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="租户ID" width="100">
            <template #default="scope">
                <div>
                    <span>{{ scope.row.tenantId || '--' }}</span>
                </div>
            </template>
        </el-table-column> -->
        <el-table-column label="创建时间" min-width="180">
            <template #default="scope">
                <div>
                    <span>{{ scope.row.createTime || '--' }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="180">
            <template #default="scope">
                <div>
                    <span>{{ scope.row.updateTime || '--' }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
            <template #default="scope">
                <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
                    编辑
                </el-button>
                <el-button
                    size="small"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                >
                    删除
                </el-button>
            </template>
        </el-table-column>
    </el-table>

    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false">
        <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
            <el-form-item label="应用名称" prop="appName">
                <el-input v-model="addInfo.appName" autocomplete="off" placeholder="请输入应用名称" />
            </el-form-item>
            <el-form-item label="应用类型" prop="appType">
                <el-select v-model="addInfo.appType" placeholder="请选择应用类型" style="width: 100%;">
                    <el-option
                        v-for="item in appTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="应用第三方ID" prop="appThirdId">
                <el-input v-model="addInfo.appThirdId" autocomplete="off" placeholder="请输入应用第三方ID" />
            </el-form-item>
            <el-form-item label="应用密钥" prop="appSecret">
                <el-input v-model="addInfo.appSecret" autocomplete="off" placeholder="请输入应用密钥" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="saveInfo()">确定</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
    >
        <span>确定删除该应用？</span>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="deleteApp()">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { required } from '@/utils/validators';
import Pagination from '@/components/Pagination.vue';

export default {
    name: 'AppManagement',
    components: {
        Pagination
    },
    data() {
        return {
            formInline: {
                appType: '',
                appName: ''
            },
            appTypeOptions: [
                { label: '小程序', value: 1 },
                { label: '公众号', value: 2 },
                { label: 'APP', value: 3 },
                { label: 'H5', value: 4 },
                { label: '其他', value: 5 }
            ],
            isUpdate: false,
            dialogTitle: '添加应用',
            dialogFormVisible: false,
            centerDialogVisible: false,
            currId: '',
            tableData: [],
            addFormRef: null,
            addRules: {
                appName: [required('请输入应用名称')],
                appType: [required('请选择应用类型')],
                appThirdId: [required('请输入应用第三方ID')],
                appSecret: [required('请输入应用密钥')]
            },
            addInfo: {
                id: '',
                appName: '',
                appType: '',
                appThirdId: '',
                appSecret: ''
            },
            total: 0,
            currentPage: 1,
            pageSize: 10
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        appTypeFilter(value) {
            if (!value && value !== 0) return '--';
            const option = this.appTypeOptions.find(item => item.value === value);
            return option ? option.label : value;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        search() {
            this.currentPage = 1;
            this.getList();
        },
        getList() {
            let that = this;
            let param = {
                page: this.currentPage,
                pageSize: this.pageSize
            };
            if (that.formInline.appType) {
                param.appType = that.formInline.appType;
            }
            if (that.formInline.appName) {
                param.appName = that.formInline.appName;
            }
            that.$axios.post(that.$store.state.platformApi + 'charge/app/page', JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.tableData = result.data.records || [];
                    that.total = result.data.total || 0;
                }
            });
        },
        showAdd() {
            this.isUpdate = false;
            this.dialogTitle = '添加应用';
            this.addInfo = {
                id: '',
                appName: '',
                appType: '',
                appThirdId: '',
                appSecret: ''
            };
            this.dialogFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs.addFormRef) {
                    this.$refs.addFormRef.clearValidate();
                }
            });
        },
        handleEdit(index, row) {
            this.isUpdate = true;
            this.dialogTitle = '编辑应用';
            this.addInfo = {
                id: row.id,
                appName: row.appName,
                appType: row.appType,
                appThirdId: row.appThirdId,
                appSecret: row.appSecret
            };
            this.dialogFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs.addFormRef) {
                    this.$refs.addFormRef.clearValidate();
                }
            });
        },
        handleDelete(index, row) {
            this.currId = row.id;
            this.centerDialogVisible = true;
        },
        saveInfo() {
            let that = this;
            this.$refs.addFormRef.validate((valid) => {
                if (!valid) return;
                let url = that.isUpdate
                    ? that.$store.state.platformApi + 'charge/app/edit'
                    : that.$store.state.platformApi + 'charge/app/add';
                that.$axios.post(url, JSON.stringify(that.addInfo)).then(result => {
                    if (result.code == 200) {
                        that.$message.success(that.isUpdate ? '编辑成功' : '添加成功');
                        that.dialogFormVisible = false;
                        that.getList();
                    }
                });
            });
        },
        deleteApp() {
            let that = this;
            that.$axios.post(that.$store.state.platformApi + 'charge/app/del/' + that.currId, {}).then(result => {
                if (result.code == 200) {
                    that.$message.success('删除成功');
                    that.centerDialogVisible = false;
                    that.getList();
                }
            });
        }
    }
};
</script>